<template>
  <div class="debug-notifications">
    <van-nav-bar title="通知调试" left-arrow @click-left="$router.back()" />

    <div class="debug-section">
      <h3>1. 当前状态</h3>
      <div class="debug-item">
        <span>未读数量:</span>
        <span class="value">{{ unreadCount }}</span>
      </div>
      <div class="debug-item">
        <span>通知总数:</span>
        <span class="value">{{ notifications.length }}</span>
      </div>
    </div>

    <div class="debug-section">
      <h3>2. 测试小红点</h3>
      <div class="badge-test">
        <van-badge :dot="unreadCount > 0">
          <van-icon name="bell" size="32" />
        </van-badge>
        <span class="badge-text">小红点: {{ unreadCount > 0 ? '显示' : '不显示' }}</span>
      </div>
    </div>

    <div class="debug-section">
      <h3>3. 通知列表</h3>
      <div class="notification-list">
        <div
          v-for="notification in notifications"
          :key="notification.id"
          class="notification-item"
          :class="{ 'unread': !notification.is_read }"
          @click="handleNotificationClick(notification)"
        >
          <div class="notification-header">
            <span class="notification-title">{{ notification.title }}</span>
            <span class="notification-status">
              {{ notification.is_read ? '已读' : '未读' }}
            </span>
          </div>
          <div class="notification-content">{{ notification.content }}</div>
          <div class="notification-footer">
            <span class="notification-time">{{ formatTime(notification.create_time) }}</span>
            <span v-if="notification.related_answer_id" class="notification-link">
              关联答题记录: {{ notification.related_answer_id }}
            </span>
          </div>
        </div>
      </div>
      <van-empty v-if="notifications.length === 0" description="暂无通知" />
    </div>

    <div class="debug-section">
      <h3>4. 操作</h3>
      <van-button type="primary" block @click="loadNotifications">刷新通知</van-button>
      <van-button type="warning" block @click="markAllAsRead" style="margin-top: 10px;">
        全部标记为已读
      </van-button>
      <van-button type="info" block @click="createTestNotification" style="margin-top: 10px;">
        创建测试通知
      </van-button>
    </div>

    <div class="debug-section">
      <h3>5. 调试信息</h3>
      <div class="debug-info">
        <div class="debug-item">
          <span>通知数据:</span>
        </div>
        <pre>{{ JSON.stringify(notifications, null, 2) }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DebugNotifications',
  data() {
    return {
      notifications: [],
      unreadCount: 0
    }
  },
  mounted() {
    this.loadNotifications()
  },
  methods: {
    async loadNotifications() {
      try {
        const response = await this.$http.get('/api/notifications')
        console.log('通知API响应:', response.data)
        if (response.data.code === 200) {
          const responseData = response.data.data || {}
          this.notifications = responseData.notifications || []
          console.log('通知列表:', this.notifications)
          this.unreadCount = this.notifications.filter(n => !n.is_read).length
          console.log('未读数量:', this.unreadCount)
          console.log('is_read值:', this.notifications.map(n => n.is_read))
        }
      } catch (err) {
        console.error('加载通知失败:', err)
        this.$toast.fail('加载通知失败')
      }
    },
    async handleNotificationClick(notification) {
      console.log('点击通知:', notification)
      try {
        await this.$http.post(`/api/notifications/${notification.id}/read`)
        console.log('标记已读成功')
        notification.is_read = true
        this.unreadCount = this.notifications.filter(n => !n.is_read).length
        console.log('更新后未读数量:', this.unreadCount)
        
        if (notification.related_answer_id) {
          console.log('跳转到答题记录:', notification.related_answer_id)
          this.$router.push(`/record/${notification.related_answer_id}`)
        } else {
          this.$toast.success('已标记为已读')
        }
      } catch (err) {
        console.error('标记已读失败:', err)
        this.$toast.fail('标记失败')
      }
    },
    async markAllAsRead() {
      try {
        await this.$http.post('/api/notifications/read-all')
        this.notifications.forEach(n => n.is_read = true)
        this.unreadCount = 0
        this.$toast.success('已全部标记为已读')
      } catch (err) {
        console.error('标记失败:', err)
        this.$toast.fail('标记失败')
      }
    },
    async createTestNotification() {
      try {
        await this.$http.post('/api/debug/create-notification', {
          title: '测试通知',
          content: '这是一条测试通知，时间: ' + new Date().toLocaleString()
        })
        this.$toast.success('创建成功')
        this.loadNotifications()
      } catch (err) {
        console.error('创建失败:', err)
        this.$toast.fail('创建失败')
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString()
    }
  }
}
</script>

<style scoped>
.debug-notifications {
  padding: 16px;
  background: #f5f5f5;
  min-height: 100vh;
}

.debug-section {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.debug-section h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #333;
}

.debug-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.debug-item:last-child {
  border-bottom: none;
}

.value {
  font-weight: bold;
  color: #1989fa;
}

.badge-test {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f8f8;
  border-radius: 4px;
}

.badge-text {
  font-size: 14px;
  color: #666;
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
}

.notification-item {
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.notification-item:active {
  background: #f5f5f5;
}

.notification-item.unread {
  background: #f0f7ff;
  border-color: #1989fa;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.notification-title {
  font-weight: bold;
  color: #333;
}

.notification-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eee;
  color: #666;
}

.notification-item.unread .notification-status {
  background: #1989fa;
  color: white;
}

.notification-content {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.notification-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
}

.notification-link {
  color: #1989fa;
}

.debug-info {
  background: #f8f8f8;
  padding: 12px;
  border-radius: 4px;
}

.debug-info pre {
  margin: 8px 0 0 0;
  padding: 8px;
  background: white;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 12px;
  overflow-x: auto;
}
</style>
